var _style, _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultLogoRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x5F_default_x5F_logo_x5F_big_x5F_room_x5F_1k_xA0_Image_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9D9D9D;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 514.2,
    cy: 511.2,
    r: 494.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M708,309.1c-93.7,0-186.5,0-279.3,0c-0.2,0.3-0.4,0.7-0.6,1c1,0.7,1.9,1.8,3,2.1c11.7,3.6,23.4,7.1,35.1,10.6 c14.1,4.1,28.2,8.1,42.3,12.2c22.5,6.6,45.1,13.2,67.6,19.9c15.3,4.6,30.6,9.3,45.9,13.7c3.2,0.9,4,2.4,4,5.5 c-0.1,174.7-0.1,349.5-0.1,524.2c0,1.3-0.1,2.6-0.2,4.5c-8.9-2.5-17.5-4.9-26.1-7.4c-28.2-8.3-56.3-16.6-84.5-24.9 c-18.8-5.6-37.5-11.3-56.2-16.9c-19.5-5.8-39.2-11.2-58.6-17.6c-36.6-12.2-70.7-29.4-100.7-53.9c-14.8-12.1-29.5-24.4-42.8-38.1 c-18.1-18.6-33.2-39.6-46.3-62.2c-17.7-30.7-30.3-63.4-38.5-97.8c-3.2-13.3-5.1-27.1-6.2-40.8c-1.4-18.1-2.1-36.4-2.1-54.6 c-0.2-145.9-0.1-291.9-0.1-437.8c0-2.1,0-4.3,0-6.7c87.9,0,175.3,0,263.3,0c0,41.9,0,84,0,126.2c101.7-22.5,196.1-6.2,281.3,53 c73.3,51,119.9,121.4,139.2,208.8c18.1,81.7,7.4,160.3-30.7,234.8C791.1,717,755.5,758.4,708,790.9C708,629.5,708,469.5,708,309.1z "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLogoRoom);
export default __webpack_public_path__ + "static/media/_default_logo_room.ef14dd43.svg";
export { ForwardRef as ReactComponent };